// extracted by mini-css-extract-plugin
module.exports = {"teamImage":"TheSummerMatchOverview_teamImage_2z5QP","teamName":"TheSummerMatchOverview_teamName_9EbJj","fullTeamName":"TheSummerMatchOverview_fullTeamName_2XM5j"};